import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import * as moment from "moment";
import { MessageService } from "primeng/api";
import { FileUpload } from "primeng/fileupload";

import { SessionService } from "../../../../app/common/services/session.service";
import { environment } from "../../../../environments/environment";
import { FILE_UPLOAD } from "../../../common/constant/fileupload.constant";
import { GLOBAL_CONSTANT } from "../../../common/constant/global.constant";
import { IN_VoterInterface } from "../../Interfaces/voter-data.interface";
import { VoterSearchAPIService } from "../../services/api/api.service";

declare var _: any;

@Component({
  selector: "app-visitor-form",
  templateUrl: "./visitor-form.component.html",
  styleUrls: ["./visitor-form.component.scss"],
  providers: [MessageService],
})
export class VisitorFormComponent implements OnInit {
  voterObj: IN_VoterInterface;
  maximunDate = new Date();
  officeData: any;
  genderTypes: any;
  profilePhoto: any;
  editableMode: boolean = false;
  rationCardData: any = [];
  selectedRationCard: any;
  castData: any;
  subCastData: any;
  photo: any;

  //assembly, Gaon And Gat_number
  assemblyData: Array<any>;
  gaonData: Array<any>;
  gatNumberData: Array<any>;
  ganData: Array<any>;
  prabhagData: Array<any>;
  prabhagAreaData: Array<any>;
  cityType: any;
  selectedCityType: any;
  villageFlag: boolean = false;
  cityFlag: boolean = false;
  gatNumberId: any;
  photoFlag: boolean = false;

  //File Upload
  uploadAPI = FILE_UPLOAD.Profile_image;
  @ViewChild("imageUpload", { static: false }) imageUpload: FileUpload;
  uploadedFiles = [];
  apiBaseUrl = environment.API_BASE;
  filetype = FILE_UPLOAD.File_type;

  @Output() afterVoterAdd = new EventEmitter();
  @Output() onSearchTriChild = new EventEmitter();
  @Input()
  get selectedVisitor(): any {
    return this.voterObj;
  }
  set selectedVisitor(value: any) {
    this.voterObj = value;
    if (!_.isEmpty(value)) {
      this.editableMode = true;
    }
    //this.editableMode = true;
    this._setData();
  }

  constructor(
    private service: VoterSearchAPIService,
    private toast: MessageService,
    private ss: SessionService
  ) {
    this.voterObj = {
      addressFields: {},
    };

    this.rationCardData = GLOBAL_CONSTANT.RATIONCARD_DATA;
    this.genderTypes = GLOBAL_CONSTANT.GENDER_TYPES;
    this.cityType = GLOBAL_CONSTANT.CITY_TYPES;
  }

  calculateAge(dob) {
    if (this.voterObj.dob != null) {
      dob = new Date(dob.model);
      if (dob != "Invalid Date") {
        this.voterObj.age = moment().diff(dob, "years");
      }
    } else {
      this.voterObj.age = 0;
    }
  }

  afterRowSelection(event) {
    this.voterObj = event.data;
  }

  private _setData() {
    this.selectedRationCard = _.find(this.rationCardData, (a) => {
      return a.value === this.voterObj.rationCard;
    });
    if (this.voterObj.dob && this.voterObj.dob != null) {
      this.voterObj.dob !== null
        ? (this.voterObj.dob = new Date(this.voterObj.dob))
        : null;
    }
    this.voterObj.cityType = _.find(this.cityType, (a) => {
      return a.value === this.voterObj.cityType;
    });
    if (
      this.voterObj.ProfileImage != "[]" &&
      this.voterObj.ProfileImage != undefined
    ) {
      this.photo = JSON.parse(this.voterObj.ProfileImage);
      if (this.photo.length != 0) {
        this.profilePhoto = this.photo[0].filename;
      }
    }
    if (this.profilePhoto != null || this.profilePhoto != undefined) {
      this.photoFlag = true;
    }
    if (this.voterObj.addressFields == null) {
      this.voterObj.addressFields = {};
    }
  }

  SaveData(visitorData) {
    if (!visitorData.valid) {
    } else {
      if (this.uploadedFiles.length >= 0) {
        //this.imageUpload.upload();
      } else {
        this.voterObj.ProfileImage = JSON.stringify(this.voterObj.ProfileImage);
        this.saveVisitorData();
      }
      this.saveVisitorData();
    }
  }

  saveVisitorData() {
    let isVisitorValid = false;
    if (this.voterObj.firstName && this.voterObj.firstName.length > 0) {
      if (this.voterObj.lastName && this.voterObj.lastName.length > 0) {
        if (this.voterObj.phone && this.voterObj.phone.length > 0) {
          if (this.voterObj.gender && this.voterObj.gender.length > 0) {
            isVisitorValid = true;
          }
        }
      }
    }
    if (this.voterObj.cityType != undefined) {
      this.voterObj.cityType = this.voterObj.cityType["value"];
    } else {
      this.voterObj.cityType = null;
    }
    if (this.selectedRationCard != undefined) {
      this.voterObj.rationCard = this.selectedRationCard.value;
    } else {
      this.voterObj.rationCard = this.rationCardData[0].value;
    }
    this.voterObj.office = this.officeData.id;
    if (isVisitorValid) {
      this.service.createVoterData(this.voterObj).subscribe((res: any) => {
        
          if (this.editableMode) {
            this.toast.add({
              severity: "success",
              summary: "Edited Successfully",
              detail: "Visitor Edited Successfully !!!",
            });
          } else {
            this.toast.add({
              severity: "success",
              summary: "Created Successfully",
              detail: "Visitor Created Successfully !!!",
            });
          }
      
        setTimeout(() => {
          this.afterVoterAdd.emit({ type: "SAVE", data: res });
        }, 1000);

        this.voterObj = {};
      });
      this.voterObj = {};
      //temporary
      //window.location.reload();
    }
  }

  afterActualSave(){
    setTimeout(() => {
      this.afterVoterAdd.emit({ type: "SAVE", data: {} });
    }, 100);
  }
  
  cancel() {
    this.afterVoterAdd.emit({ type: "CANCEL" });
    this.voterObj = {};
  }

  ngOnInit() {
    this.officeData = this.ss.getOffice();
  }
}
function _isEmpty(voterObj: IN_VoterInterface) {
  throw new Error("Function not implemented.");
}
